import queryString from 'query-string';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { listVendors } from 'redux/productFilters/actions';

class VendorFilter extends Component {
  constructor(props) {
    super(props);
    const { location } = this.props;
    const queryObj = queryString.parse(location.search);
    this.state = {
      vendorId: queryObj.vendorId
    };
  }

  componentDidMount() {
    this.listVendors();
  }

  componentDidUpdate(prevProps) {
    const { props } = this;
    if (prevProps.match.params.slug !== props.match.params.slug) {
      this.listVendors();
    }
  }

  listVendors = () => {
    const { props } = this;
    const { slug } = props.match.params;
    props.listVendors(slug);
  };

  handleChange = (e) => {
    const vendorId = e.target.value;
    this.setState({ vendorId });
    this.handleQueryChange(vendorId);
  };

  handleQueryChange = (vendorId) => {
    const { location, history } = this.props;
    const parsed = queryString.parse(location.search);
    if (vendorId === '') {
      delete parsed.vendorId;
    } else {
      parsed.vendorId = vendorId;
    }
    delete parsed.page;
    const stringified = queryString.stringify(parsed);
    let url = location.pathname;
    if (stringified.length > 0) {
      url += `?${stringified}`;
    }
    history.push(url);
  };

  render() {
    const { vendors } = this.props;
    const { vendorId } = this.state;
    if (vendors.length === 0) {
      return null;
    }
    return (
      <>
        <div className="c7-selectbox">
          <label htmlFor="vendorId">
            Vendor:
            <span className="c7-selectboxWrap">
              <select
                id="vendorId"
                name="vendorId"
                value={vendorId}
                onChange={this.handleChange}
              >
                <option value="" />
                {vendors.map((wt) => (
                  <option value={wt.vendorId} key={wt.vendorId}>
                    {wt.title}
                  </option>
                ))}
              </select>
            </span>
          </label>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  vendors: state.productFilter.vendors
});

export default withRouter(
  connect(mapStateToProps, { listVendors })(VendorFilter)
);
